import { AdviseCurrentSupplier } from '../../../../types/advise';
import { formatCurrency } from '../../../../utils/helpers';

export const dollars = (amount?: number | null) => formatCurrency(amount, { zeroDisplay: '$0.00' });

export const baselineExclusions = (outOfScope: number, taxesExcluded: number): string | null =>
  [
    outOfScope ? `Out of scope ${dollars(outOfScope)} /mo` : null,
    taxesExcluded ? `Taxes excluded ${dollars(taxesExcluded)} /mo` : null
  ]
    .filter(Boolean)
    .join(' · ') || null;

/** The in-scope monthly spend of the suppliers whose entry is finished; the rest are "Not included yet". */
export const currentMonthlySpend = (suppliers: AdviseCurrentSupplier[]): number =>
  suppliers.reduce((total, supplier) => (supplier.complete ? total + supplier.monthly_amount : total), 0);
